// extracted by mini-css-extract-plugin
module.exports = {"container":"Year_container__3AQLh","header":"Year_header__68lIS","year":"Year_year__1jLiT","btnNext":"Year_btnNext__3gJDC"};